<template>
  <div>
    <v-layout row wrap>
      <v-flex md4>
        <v-card>
          <v-layout row wrap>
            <v-flex md12 text-xs-center class="subheading pt-4">
              {{new Intl.NumberFormat('es-VE').format(totalOfSeries)}} clientes notificados
            </v-flex>
          </v-layout>
          <div :id="graphicIdOne" class="funnel-graphic py-4"></div>
        </v-card>
      </v-flex>
      <v-flex md4>
        <v-card>
          <v-layout row wrap>
            <v-flex md12 text-xs-center class="subheading pt-4">
              Enviados a {{new Intl.NumberFormat('es-VE').format(totalOfReacheds)}} clientes
            </v-flex>
          </v-layout>
          <div :id="graphicIdTwo" class="funnel-graphic py-4"></div>
        </v-card>
      </v-flex>
      <v-flex md4 pl-3>
        <vue-perfect-scrollbar class="elevation-2 white" :settings="scrollbarSettings">
          <v-list class="negative-statuses-list pa-0">
            <template v-if="negativeStatuses.length">
              <v-subheader>
                <v-layout row wrap>
                  <v-flex md7>
                    Contacto:
                    <span md5 text-xs-left v-if="seriesReacheds.length > 0">
                      {{new Intl.NumberFormat('es-VE').format(this.seriesReacheds[0][0].value)}}
                    </span>
                  </v-flex>
                </v-layout>
              </v-subheader>
              <template v-for="(status, i) in negativeStatuses">
                <v-list-tile v-if="status.status_type === 'reached'">
                  <v-list-tile-content>
                    <v-layout justify-center align-center class="w-100">
                      <v-flex md1 class="mr-4">
                        <v-icon>
                          fa-{{icons[status.status]}}
                        </v-icon>
                      </v-flex>
                      <v-flex md5 pl-2>
                        <p class="f0-9em d-inline text-medium-light">
                          {{ status.status }}
                        </p>
                      </v-flex>
                      <v-flex md3 pl-3 text-xs-center>
                        <p class="f0-9em d-inline text-medium-light">
                          {{ new Intl.NumberFormat('es-VE').format(status.total) }}
                        </p>
                      </v-flex>
                      <v-flex md4 pl-3 text-xs-center>
                        <p class="f0-9em d-inline text-medium-light green--text">
                          {{ settingPercent(status.total, 'reached') }}
                        </p>
                      </v-flex>
                    </v-layout>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider v-if="status.status_type === 'reached'"></v-divider>
              </template>
              <v-subheader>
                <v-layout row wrap>
                  <v-flex md7>
                    Sin contacto:
                    <span md5 text-xs-left v-if="seriesReacheds.length > 0">
                      {{new Intl.NumberFormat('es-VE').format(this.seriesReacheds[1][0].value)}}
                    </span>
                  </v-flex>
                </v-layout>
              </v-subheader>
              <template v-for="(status, i) in negativeStatuses">
                <v-list-tile v-if="status.status_type === 'not_reached'">
                  <v-list-tile-content>
                    <v-layout justify-center align-center class="w-100">
                      <v-flex md1 class="mr-4">
                        <v-icon>
                          fa-{{icons[status.status]}}
                        </v-icon>
                      </v-flex>
                      <v-flex md5 pl-2>
                        <p class="f0-9em d-inline text-medium-light">
                          {{ status.status }}
                        </p>
                      </v-flex>
                      <v-flex md3 pl-3 text-xs-center>
                        <p class="f0-9em d-inline text-medium-light">
                          {{ new Intl.NumberFormat('es-VE').format(status.total) }}
                        </p>
                      </v-flex>
                      <v-flex md4 pl-3 text-xs-center>
                        <p class="f0-9em d-inline text-medium-light red--text">
                          {{ settingPercent(status.total, 'not_reached') }}
                        </p>
                      </v-flex>
                    </v-layout>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider v-if="status.status_type === 'not_reached'"></v-divider>
              </template>
              <v-subheader>
                <v-layout row wrap>
                  <v-flex md7>
                    No enviado:
                    <span md5 text-xs-left v-if="seriesTotals.length > 0">
                      {{new Intl.NumberFormat('es-VE').format(this.seriesTotals[2][0].value)}}
                    </span>
                  </v-flex>
                </v-layout>
              </v-subheader>
              <template v-for="(status, i) in negativeStatuses">
                <v-list-tile v-if="status.status_type === 'not_sent'">
                  <v-list-tile-content>
                    <v-layout justify-center align-center class="w-100">
                      <v-flex md1 class="mr-4">
                        <v-icon>
                          fa-{{icons[status.status]}}
                        </v-icon>
                      </v-flex>
                      <v-flex md5 pl-2>
                        <p class="f0-9em d-inline text-medium-light">
                          {{ status.status }}
                        </p>
                      </v-flex>
                      <v-flex md3 pl-3 text-xs-center>
                        <p class="f0-9em d-inline text-medium-light">
                          {{ new Intl.NumberFormat('es-VE').format(status.total) }}
                        </p>
                      </v-flex>
                      <v-flex md4 pl-3 text-xs-center>
                        <p class="f0-9em d-inline text-medium-light red--text">
                          {{ settingPercent(status.total, 'not_sent') }}
                        </p>
                      </v-flex>
                    </v-layout>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider v-if="status.status_type === 'not_sent'"></v-divider>
              </template>
            </template>
            <v-list-tile v-else>
              <v-list-tile-content>
                <v-layout justify-center align-center class="w-100 mt-2">
                  <v-flex md12 class="mr-4 text-xs-center">
                    <v-icon>
                      fas fa-info-circle
                    </v-icon>
                    <p class="f0-9em d-inline text-medium-light ml-3">
                      No hay nada que mostrar
                    </p>
                  </v-flex>
                </v-layout>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </vue-perfect-scrollbar>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
/* eslint-disable */
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Chartist from 'chartist';
import ctBarLabelsMixin from '@/mixins/ctBarLabels';
import EventBus from '@/event-bus';

const qs = require('qs');

window.Chartist = Chartist;

require('@/assets/js/ctBarLabels.js');

export default {
  props: {
    graphicIdOne: {
      type: String,
      required: true,
    },
    graphicIdTwo: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
    searchOnCreate: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    VuePerfectScrollbar,
  },
  mixins: [
    ctBarLabelsMixin,
  ],
  created() {
    EventBus.$on(`${this.graphicIdOne}Reload`, () => {
      this.searchData();
    });
    EventBus.$on(`${this.graphicIdOne}Rebuild`, () => {
      this.buildFirstGraphic();
    });
    if (this.searchOnCreate) {
      this.searchData();
    }
  },
  destroyed() {
    EventBus.$off(`${this.graphicIdOne}Reload`);
    EventBus.$off(`${this.graphicIdOne}Rebuild`);
  },
  data() {
    return {
      seriesTotals: [],
      seriesReacheds: [],
      totalOfSeries: 0,
      totalOfReacheds: 0,
      negativeStatuses: [],
      icons: {
        Invalido: 'shield-alt',
        'Marcado SPAM': 'user-astronaut',
        Rebotado: 'backward',
        Conectado: 'user-check',
        Compromiso: 'calendar-check',
        Entregado: 'check-double',
        Enviado: 'check',
        Leido: 'book-open',
        Equivocado: 'user-times',
        'No enviado': 'comment-slash',
        'No entregado': 'calendar-times',
        Ocupado: 'user-clock',
        Error: 'times-circle',
        'No contesta': 'phone-slash',
        'Buzon de Voz': 'headset',
        Rechazado: 'user-alt-slash',
      },
      scrollbarSettings: {
        minScrollbarLength: 160,
        maxScrollbarLength: 320,
        wheelSpeed: 2,
      },
    };
  },
  methods: {
    settingPercent(total, type) {
      let response = 0;
      if (type === 'reached') {
        response = `${parseFloat((total/this.seriesReacheds[0][0].value)*100).toFixed(2)} %`;
      } else if(type === 'not_sent') {
        response = `${parseFloat((total/this.seriesTotals[2][0].value)*100).toFixed(2)} %`;
      } else {
        response = `${parseFloat((total/this.seriesReacheds[1][0].value)*100).toFixed(2)} %`;
      }
      return response;
    },
    settingNullVars(arrKey, arrToSet) {
      let arrayToReturn = [];
      for (let i = 0; i < arrKey.length; i += 1) {
        let obj = arrToSet.find(item => item.status_type === arrKey[i]);
        if (!obj) {
          arrayToReturn.push({
            status_type: arrKey[i],
            total: 0,
          });
        } else {
          arrayToReturn.push(obj);
        }
      }

      return arrayToReturn;
    },
    searchData() {
      this.axios.get(`${this.url}?${qs.stringify(this.filters)}`).then((response) => {
        this.seriesTotals = [];
        this.seriesReacheds = [];
        let totals = [];
        let sendeds = [];
        let reacheds = [];
        const totalLabels = [
          'not_sent',
          'pending',
        ];
        const reachedLabels = [
          'reached',
          'not_reached',
        ];
        totals = this.settingNullVars(totalLabels, response.data.status_type);
        sendeds = this.settingNullVars(reachedLabels, response.data.status_type);
        this.totalOfReacheds = this.sum('total', sendeds);
        totals.push({
          status_type: 'sents',
          total: this.totalOfReacheds,
        });
        totals.reverse();
        this.totalOfSeries = this.sum('total', totals);
        totals.forEach((item) => {
          this.seriesTotals.push([{
            meta: `(${Math.round(((item.total / this.totalOfSeries) || 0) * 100, 10)}%)`,
            value: item.total,
          }]);
        });
        sendeds.forEach((item) => {
          this.seriesReacheds.push([{
            meta: `(${Math.round(((item.total / this.totalOfReacheds) || 0) * 100, 10)}%)`,
            value: item.total,
          }]);
        });
        this.buildGraphic(this.graphicIdOne, this.totalOfSeries, this.seriesTotals, ['Enviado', 'Pendiente', 'No enviado'], 100);
        this.buildGraphic(this.graphicIdTwo, this.totalOfReacheds, this.seriesReacheds, ['Contactados', 'No contactados'], 150);
        this.negativeStatuses = response.data.status;
      }).catch(() => {});
    },
    buildGraphic(graphicId, maxVal, series, labels, seriesDistance) {
      const maxValue = typeof(maxVal) === 'object' ? this.graphicMaxValue(maxVal) : maxVal;
      new Chartist.Bar(`#${graphicId}`, { // eslint-disable-line
        labels: labels,
        series: series,
      }, {
        height: '55vh',
        seriesBarDistance: seriesDistance,
        chartPadding: {
          bottom: 10,
          left: 30,
          right: 30,
        },
        plugins: [
          Chartist.plugins.ctBarLabels(),
        ],
        axisY: {
          type: Chartist.FixedScaleAxis,
          high: maxValue + this.graphicScale(maxValue),
          ticks: this.graphicTicks(maxValue),
          offset: 0,
        },
      });
    },
    sum(prop, array) {
      let total = 0;
      for (let i = 0; i < array.length; i += 1) {
        total += array[i][prop];
      }
      return total;
    },
  },
  watch: {
    seriesTotals(newVal) {
      EventBus.$emit(`${this.graphicIdOne}Series`, newVal);
    },
    filters: {
      handler() {
        this.searchData();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.negative-statuses-list {
  height: 65vh;
}

.funnel-graphic {
  height: 60vh;
}
</style>


// WEBPACK FOOTER //
// src/components/panel/payment_smy/Graphics.vue